interface State {
  dataSource: any[]
  isAddModalVisivle: boolean
  selectedRowKeys: any[]
  invoiceData: any[] // 开票信息
  formData: any
  isSubmitButtonLoading: boolean
}
type ActionType =
  | 'setDataSource'
  | 'setSelectedRowKeys'
  | 'setIsAddModalVisivle'
  | 'setInvoiceData'
  | 'setFormDataAction'
  | 'resetStateAction'
  | 'setIsSubmitButtonLoadingAction'

interface Action {
  type: ActionType
  payload: any
}

const initialState: State = {
  dataSource: [],
  isAddModalVisivle: false,
  selectedRowKeys: [],
  invoiceData: [],
  formData: {},
  isSubmitButtonLoading: false,
}

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setDataSource':
      newstate.dataSource = action.payload
      return newstate
    case 'setSelectedRowKeys':
      newstate.selectedRowKeys = action.payload
      return newstate
    case 'setIsAddModalVisivle':
      newstate.isAddModalVisivle = action.payload
      return newstate
    case 'setInvoiceData':
      newstate.invoiceData = action.payload
      return newstate
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'resetStateAction':
      return initialState
    case 'setIsSubmitButtonLoadingAction':
      newstate.isSubmitButtonLoading = action.payload
      return newstate
    default:
      return newstate
  }
}

/**
 * 设置添加订单弹窗显示
 * @param val
 * @returns
 */
export const setIsAddModalVisivle = (val: any): Action => ({
  type: 'setIsAddModalVisivle',
  payload: val,
})

/**
 * 设置当前表格数据
 * @param val
 * @returns
 */
export const setDataSource = (val: any): Action => ({
  type: 'setDataSource',
  payload: val,
})

/**
 * 设置当前表格选中行
 * @param val
 * @returns
 */
export const setSelectedRowKeys = (val: any): Action => ({
  type: 'setSelectedRowKeys',
  payload: val,
})

/**
 * 设置开票信息数据
 * @param val
 * @returns
 */
export const setInvoiceData = (val: any[]): Action => ({
  type: 'setInvoiceData',
  payload: val,
})
/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): Action => ({
  type: 'setFormDataAction',
  payload: val,
})

/**
 * 重置redux内容，关闭页面时调用
 * @returns
 */
export const resetStateAction = (): Action => ({
  type: 'resetStateAction',
  payload: undefined,
})

/**
 * 提交按钮防重处理
 * @param val
 * @returns
 */
export const setIsSubmitButtonLoadingAction = (val: boolean): Action => ({
  type: 'setIsSubmitButtonLoadingAction',
  payload: val,
})
interface State {
  dataSource: any[]
  isAddModalVisivle: boolean
  selectedRowKeys: any[]
  invoiceData: any[] // 开票信息
  formData: any
  isSubmitButtonLoading: boolean
}
type ActionType =
  | 'setDataSource'
  | 'setSelectedRowKeys'
  | 'setIsAddModalVisivle'
  | 'setInvoiceData'
  | 'setFormDataAction'
  | 'resetStateAction'
  | 'setIsSubmitButtonLoadingAction'

interface Action {
  type: ActionType
  payload: any
}

const initialState: State = {
  dataSource: [],
  isAddModalVisivle: false,
  selectedRowKeys: [],
  invoiceData: [],
  formData: {},
  isSubmitButtonLoading: false,
}

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setDataSource':
      newstate.dataSource = action.payload
      return newstate
    case 'setSelectedRowKeys':
      newstate.selectedRowKeys = action.payload
      return newstate
    case 'setIsAddModalVisivle':
      newstate.isAddModalVisivle = action.payload
      return newstate
    case 'setInvoiceData':
      newstate.invoiceData = action.payload
      return newstate
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'resetStateAction':
      return initialState
    case 'setIsSubmitButtonLoadingAction':
      newstate.isSubmitButtonLoading = action.payload
      return newstate
    default:
      return newstate
  }
}

/**
 * 设置添加订单弹窗显示
 * @param val
 * @returns
 */
export const setIsAddModalVisivle = (val: any): Action => ({
  type: 'setIsAddModalVisivle',
  payload: val,
})

/**
 * 设置当前表格数据
 * @param val
 * @returns
 */
export const setDataSource = (val: any): Action => ({
  type: 'setDataSource',
  payload: val,
})

/**
 * 设置当前表格选中行
 * @param val
 * @returns
 */
export const setSelectedRowKeys = (val: any): Action => ({
  type: 'setSelectedRowKeys',
  payload: val,
})

/**
 * 设置开票信息数据
 * @param val
 * @returns
 */
export const setInvoiceData = (val: any[]): Action => ({
  type: 'setInvoiceData',
  payload: val,
})
/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): Action => ({
  type: 'setFormDataAction',
  payload: val,
})

/**
 * 重置redux内容，关闭页面时调用
 * @returns
 */
export const resetStateAction = (): Action => ({
  type: 'resetStateAction',
  payload: undefined,
})

/**
 * 提交按钮防重处理
 * @param val
 * @returns
 */
export const setIsSubmitButtonLoadingAction = (val: boolean): Action => ({
  type: 'setIsSubmitButtonLoadingAction',
  payload: val,
})
